import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Input, Card, CardBody, CardHeader } from "reactstrap";
import { Link, Redirect, withRouter } from "react-router-dom";
import {Table, Thead, Tbody, Tr, Th, Td} from 'react-super-responsive-table';
import { AvForm, AvField, AvInput } from "availity-reactstrap-validation";
import { paramPost } from "../../apiHelpers/commonApiHelper";

import { connect } from 'react-redux';


import { getMedia } from '../../store/actions';
import Select from "react-select";
//i18n
import { withNamespaces } from 'react-i18next';
import moment from "moment";
import Dropzone from "react-dropzone";
import {trim} from "leaflet/src/core/Util";
import toastr from 'toastr';

const Setup = (props) => {


    useEffect(() => {
        // props.getMedia()
    }, [])

    const[loading, setLoading] = useState(false)

    const handlePlayerCode = (e, values) => {
        e.persist();
        setLoading(true);
        const code = values.player_code.replace(/\s/g, '');
        const displayName = (values.player_name || "").trim();
        paramPost("/api/v1/players", { player_code: code, player_name: displayName })
            .then((result) => {
                setLoading(false);
                if(result.data.success) {
                    window.location.href = `/add_device/${code}`
                } else {
                    toastr.error(result.data.message, "ERROR")
                }
            })
            .catch((err) => {
                toastr.error("Something went wrong!", "ERROR")
                setLoading(false);
            })
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row className="setup-class">
                        <Col>
                            <Card className="card-style">
                                <CardHeader>Setup Player with Code</CardHeader>
                                <CardBody>
                                    <p className="description">
                                        Once you've installed <span>RDS</span> APK, type in the given code. Spaces don't matter.
                                    </p>
                                    <AvForm
                                        className="outer-repeater row m-auto"
                                        style={{width: "100%"}}
                                        onValidSubmit={(e,v) => { handlePlayerCode(e,v) }}
                                    >
                                        <Col sm={12} className="p-0">
                                            <div className="form-group">
                                                <AvField
                                                    type="input"
                                                    label={"Display name"}
                                                    name="player_name"
                                                    placeholder={"e.g. Lobby screen"}
                                                    validate={{ required: { value: true, errorMessage: "Please enter a display name" } }}
                                                >
                                                </AvField>
                                            </div>
                                        </Col>
                                        <Col sm={12} className="p-0">
                                            <div className="form-group">
                                                <AvField
                                                    type="input"
                                                    label={"Player code"}
                                                    name="player_code"
                                                    validate={{ required: { value: true } }}
                                                    // onChange={getStudent}
                                                >
                                                </AvField>
                                            </div>
                                        </Col>
                                        <Col sm={12} className="p-0 text-right">
                                            <button className="btn btn-orange" disabled={loading}>
                                                {!loading ?
                                                    "Setup Player" :
                                                    <i className="fas fa-spinner fa-spin" style={{width: "100px"}}></i>
                                                }
                                            </button>
                                        </Col>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    const { media } = state.CampaignReducer;
    return { media };
}

export default withRouter(connect(mapStateToProps, { getMedia })(withNamespaces()(Setup)));
